module.exports = __webpack_public_path__ + "static/img/documentoPDF.1df6ad9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/documentoPDF.png
// module id = bJCx
// module chunks = 9